import {
    GET_STATIC_DATA_REQUEST,
    GET_STATIC_DATA_SUCCESS,
    GET_STATIC_DATA_ERROR,
    FETCH_UNDERLYING_MERCHANT_STATIC_REQUEST,
    FETCH_UNDERLYING_MERCHANT_STATIC_SUCCESS,
    FETCH_UNDERLYING_MERCHANT_STATIC_ERROR,
    FETCH_STATIC_INFO_REQUEST,
    FETCH_STATIC_INFO_SUCCESS,
    FETCH_STATIC_INFO_ERROR,
    FETCH_AUDIT_TRAIL_STATIC_REQUEST,
    FETCH_AUDIT_TRAIL_STATIC_SUCCESS,
    FETCH_AUDIT_TRAIL_STATIC_ERROR,
    FETCH_CHARGEBACK_STATIC_DATA_REQUEST,
    FETCH_CHARGEBACK_STATIC_DATA_SUCCESS,
    FETCH_CHARGEBACK_STATIC_DATA_ERROR,
} from './staticData.constants';

// Get Static Data
export const getStaticDataRequest = () => ({
    type: GET_STATIC_DATA_REQUEST,
});

export const getStaticDataSuccess = payload => ({
    type: GET_STATIC_DATA_SUCCESS,
    payload,
});

export const getStaticDataError = payload => ({
    type: GET_STATIC_DATA_ERROR,
    payload,
});
export const fetchUnderlyingMerchantStaticRequest = () => ({
    type: FETCH_UNDERLYING_MERCHANT_STATIC_REQUEST,
});

export const fetchUnderlyingMerchantStaticSuccess = payload => ({
    type: FETCH_UNDERLYING_MERCHANT_STATIC_SUCCESS,
    payload,
});

export const fetchUnderlyingMerchantStaticError = payload => ({
    type: FETCH_UNDERLYING_MERCHANT_STATIC_ERROR,
    payload,
});

export const fetStaticInfoRequest = () => ({
    type: FETCH_STATIC_INFO_REQUEST,
});

export const fetStaticInfoSuccess = payload => ({
    type: FETCH_STATIC_INFO_SUCCESS,
    payload,
});

export const fetStaticInfoError = payload => ({
    type: FETCH_STATIC_INFO_ERROR,
    payload,
});

export const fetchAuditTrailStaticRequest = () => ({
    type: FETCH_AUDIT_TRAIL_STATIC_REQUEST,
});

export const fetchAuditTrailStaticSuccess = payload => ({
    type: FETCH_AUDIT_TRAIL_STATIC_SUCCESS,
    payload,
});

export const fetchAuditTrailStaticError = payload => ({
    type: FETCH_AUDIT_TRAIL_STATIC_ERROR,
    payload,
});

export const fetchChargebackStaticRequest = () => ({
    type: FETCH_CHARGEBACK_STATIC_DATA_REQUEST,
});

export const fetchChargebackStaticSuccess = payload => ({
    type: FETCH_CHARGEBACK_STATIC_DATA_SUCCESS,
    payload,
});

export const fetchChargebackStaticError = payload => ({
    type: FETCH_CHARGEBACK_STATIC_DATA_ERROR,
    payload,
});
